// Helper to get labels for a path in the tree
function getPathLabels(data, pathArr) {
  let labels = [];
  let currentLevel = data;
  for (let i = 0; i < pathArr.length; i++) {
    const idx = parseInt(pathArr[i], 10);
    if (!currentLevel || !currentLevel[idx]) break;
    labels.push(currentLevel[idx].text);
    currentLevel = currentLevel[idx].children;
  }
  return labels;
}

export default getPathLabels;
